/**
 *
 * Azure Active Directory
 *
 */

import React from 'react';

import { CloudProviders } from '@ariksa/cloud-account/api';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Form } from 'components/DataEntry/Form';
import { selectSetup } from 'containers/Setup/selectors';
import { actions as setupActions } from 'containers/Setup/slice';

import { formStyles } from '../../../../../Integrations/styles';

export const AddAzureAD = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { onboardAccount } = useSelector(selectSetup);

  const handleReset = () => {
    navigate('/setup/accounts');
  };
  const handleSubmit = data => {
    const { client_id, client_credential, name, authority } = data;
    dispatch(
      setupActions.onboardAccount({
        q: {
          cloudAccountCreateRequest: {
            cloud_type: CloudProviders.AzureAd,
            name,
            azure_ad: { client_id, client_credential, authority },
          },
        },
        onSuccess: () => navigate('/setup/accounts'),
      }),
    );
  };

  return (
    <>
      <Form
        title="Add Entra ID"
        iconType={CloudProviders.AzureAd}
        isTitleIconFilled={false}
        schema={{
          name: {
            type: 'text',
            label: 'Name',
            isRequired: true,
            autoFocus: true,
          },
          client_id: {
            type: 'text',
            label: 'Client ID',
            isRequired: true,
          },
          client_credential: {
            type: 'text',
            label: 'Client Credential',
            isRequired: true,
            htmlInputType: 'password',
            passwordShow: true,
          },
          authority: {
            type: 'text',
            label: 'Authority',
            isRequired: true,
          },
        }}
        //formOptions={{ defaultValues: { ...state } }}
        styles={formStyles}
        buttonOptions={{
          submit: {
            name: 'OK',
            isLoading: onboardAccount.isLoading,
          },
          reset: {
            isVisible: true,
            onClick: handleReset,
          },
        }}
        handleSubmit={handleSubmit}
      />
    </>
  );
};
